import * as React from "react"

import { createNavigator, MoveHandle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderFunction, NavigatorProps } from "Catalog/Edit/shared/components/Navigator/types"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ChargeId } from "shared/hubrise/ids"
import { ICharge } from "shared/hubrise/models"

import { StyledCharge, Name } from "./Styles"

interface ChargeProps {
  items: Array<ICharge>
  selectedId?: ChargeId
}

const ChargeNavigator = createNavigator<ICharge>()

const Navigator = ({ items, selectedId }: ChargeProps): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const selectItem = React.useCallback(
    (charge: ICharge): void => navigate(catalogNavigation.editPath("charge", charge.id)),
    [catalogNavigation, navigate],
  )

  const moveItem: NavigatorProps<ICharge>["moveItem"] = React.useCallback(
    (item, newPosition) => editor.charge.move(item, newPosition),
    [editor],
  )

  const renderItem: ItemRenderFunction<ICharge> = React.useCallback(
    (item, itemRenderProps) => (
      <StyledCharge {...itemRenderProps}>
        <Name>{item.name}</Name>
        <MoveHandle {...itemRenderProps} />
      </StyledCharge>
    ),
    [],
  )

  return <ChargeNavigator {...{ items, selectItem, selectedId, moveItem, renderItem }} />
}

export default Navigator
